import React from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';

import CtaButton from '../components/CtaButton/CtaButton';

interface IProps {
  title?: string;
  children: React.ReactNode;
  rightButtonChildren?: React.ReactNode;
  onClickRightButton?: () => void;
  isLoading?: boolean;
  error: Error | null;
  containerSx?: object;
}

const PageContentLayout = ({
  children,
  title,
  rightButtonChildren,
  onClickRightButton,
  isLoading = false,
  error,
  containerSx,
}: IProps) => {
  return (
    <Box p={4} position="relative" height="100%" flex={1} sx={containerSx}>
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
        gap={20}
      >
        <Typography variant="h4" fontWeight="bold" mb={6}>
          {title}
        </Typography>
        {rightButtonChildren && !isLoading && !error && (
          <CtaButton variant="contained" onClick={onClickRightButton}>
            {rightButtonChildren}
          </CtaButton>
        )}
      </Box>

      {!isLoading && error && (
        <Alert severity="error">
          {error.message ? `Error: ${error.message}` : 'An Error occurred'}
        </Alert>
      )}

      {!isLoading && !error && children}

      {isLoading && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Box>
      )}
    </Box>
  );
};

export default PageContentLayout;
